import { render } from "./LanguageIcon.vue?vue&type=template&id=d598a8ca&ts=true"
import script from "./LanguageIcon.vue?vue&type=script&lang=ts"
export * from "./LanguageIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__